class OneTrustButton {
  constructor() {

    const buttons = document.querySelectorAll('a.privacy-policy');

    if (!buttons) {
      return;
    }

    buttons.forEach((button) => {
      button.setAttribute('href', '#')
      button.setAttribute('onclick', 'OneTrust.ToggleInfoDisplay();return false;')
    })

  }
}


document.addEventListener('DOMContentLoaded', () => {
  new OneTrustButton();
})
